var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurkcell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 29,
    viewBox: "0 0 122 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15744_303326)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1725 14.3539C64.7111 13.7006 64.9892 12.9271 64.9892 12.016C64.9892 10.847 64.5721 9.85001 63.7381 9.09364C62.8692 8.2857 61.705 7.89032 60.2802 7.89032H54.6328V21.1096H57.7953V16.0213H59.3592L62.0526 21.1096H65.7016L62.5565 15.5056C63.2168 15.2478 63.7554 14.8696 64.1725 14.3539ZM61.3575 13.0818C61.0273 13.3568 60.6277 13.4944 60.089 13.4944H57.7779V10.572H60.089C60.6103 10.572 61.0273 10.7095 61.3575 10.9846C61.6703 11.2596 61.8267 11.6034 61.8267 12.0332C61.8267 12.4629 61.6703 12.8067 61.3575 13.0818Z",
    fill: "#034EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8017 16.4167C49.8017 17.0871 49.6106 17.6028 49.2109 17.981C48.8287 18.3592 48.3074 18.5483 47.6297 18.5483C46.952 18.5483 46.4307 18.3592 46.0484 17.981C45.6662 17.6028 45.475 17.0871 45.475 16.4167V7.89032H42.3125V16.5026C42.3125 17.8951 42.8338 19.0468 43.8416 19.9235C44.8495 20.783 46.1179 21.2128 47.6297 21.2128C49.1241 21.2128 50.4099 20.783 51.4178 19.9235C52.443 19.0468 52.9469 17.8951 52.9469 16.5026V7.89032H49.8017V16.4167Z",
    fill: "#034EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6172 10.572H34.2315V21.1096H37.3766V10.572H40.9909V7.89032H30.6172V10.572Z",
    fill: "#034EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.3692 7.89032H74.4595L69.9242 13.0646V7.89032H66.7617V21.1096H69.9242V17.1387L71.4534 15.454L74.9113 21.1096H78.5951L73.5559 13.2193L78.3692 7.89032Z",
    fill: "#034EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.19 18.428V7.89032H112.027V21.1096H121.133V18.428H115.19Z",
    fill: "#034EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.163 7.89032H102V21.1096H110.827V18.428H105.163V7.89032Z",
    fill: "#034EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0501 10.4173C85.1796 10.4173 85.8746 10.9674 86.1874 12.0848L86.2395 12.2567H89.4542L89.402 11.9816C89.1588 10.6064 88.5332 9.54061 87.5775 8.81862C86.6218 8.09663 85.4402 7.71844 84.0501 7.71844C83.4941 7.71844 82.9728 7.78721 82.4688 7.90754C80.3837 8.38887 79.0109 9.72971 78.2637 12.016C78.0031 12.8583 77.9336 13.8038 77.9336 14.457C77.9336 15.2134 78.0379 16.0213 78.1942 16.6746C78.507 17.7919 79.0631 18.7718 79.7929 19.4938C79.8971 19.6141 80.0014 19.7173 80.1056 19.8204C81.1656 20.8002 82.4862 21.2988 84.0327 21.2988C85.4055 21.2988 86.5871 20.9378 87.5254 20.2158C88.5158 19.4766 89.1588 18.3936 89.402 17.0356L89.4542 16.7605H86.2395L86.1874 16.9324C85.892 18.0498 85.1969 18.5999 84.0501 18.5999C83.3203 18.5999 82.7642 18.4967 82.1734 17.981C81.878 17.6716 81.6348 17.345 81.461 16.9668C81.2699 16.5714 81.0614 15.6947 81.0614 14.4227C81.0614 12.8411 81.4089 11.7754 82.1734 11.0534C82.6426 10.6236 83.2334 10.4173 84.0501 10.4173Z",
    fill: "#034EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.7422 21.1096H100.299V18.428H93.9047V15.7807H99.3435V13.1162H93.9047V10.572H100.299V7.89032H90.7422V21.1096Z",
    fill: "#034EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_15744_303326",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -37,
    width: 148,
    height: 103
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 -36.6669H-12.1445V65.6669H134.148V-36.6669Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_15744_303326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1991 7.4434C24.226 5.91347 23.0271 4.65858 21.637 3.67873C20.2468 2.69888 18.6482 2.01127 16.8758 1.59871C13.9392 0.911096 11.1068 1.22052 8.36135 2.44103C6.8496 3.11145 5.49423 4.03973 4.34739 5.20867C2.90514 6.68703 1.86256 8.35449 1.21963 10.211C1.21963 10.2282 1.20225 10.2454 1.20225 10.2626C1.18488 10.3314 1.1675 10.4001 1.13275 10.4689C0.472442 12.6177 1.09799 13.8038 2.0537 12.8068C2.08845 12.7552 2.1232 12.7208 2.17533 12.6864C2.19271 12.6692 2.21009 12.6521 2.22746 12.6349C3.33956 11.2425 5.12933 10.0735 5.12933 10.0735C5.58112 9.76409 6.05028 9.47185 6.53682 9.19681C7.09287 8.87019 7.68367 8.57796 8.22234 8.37168C8.22234 8.37168 8.72625 8.1482 8.86526 7.4434C8.86526 7.42621 8.86526 7.40902 8.86526 7.40902V7.39183C8.95215 6.80736 9.59507 5.20867 11.3675 5.10552C11.9235 5.03676 12.4796 5.12271 12.9661 5.36338C13.8176 5.77595 14.4779 6.58389 14.6169 7.54654C14.7211 8.32011 14.53 9.05929 14.1303 9.62657C14.113 9.66095 14.0782 9.69533 14.0608 9.72971C14.0608 9.7469 14.0434 9.7469 14.0434 9.76409C13.7133 10.1938 13.2441 10.5205 12.7055 10.7096C12.3753 10.8299 12.0452 10.8986 11.7324 10.8986C11.5239 10.9158 11.3153 10.8986 11.0894 10.8471C10.8462 10.7955 10.6029 10.7096 10.4118 10.6064C10.0642 10.4517 9.78622 10.2626 9.68196 10.1767C9.59507 10.1079 9.50819 10.0563 9.42131 10.0391C9.23017 10.0048 9.07378 10.0391 8.96952 10.0907C8.90002 10.1251 8.86526 10.1423 8.83051 10.1767C8.3961 10.5205 7.99644 10.8986 7.61416 11.2768C6.60633 12.3254 5.75488 13.5288 5.35522 14.1132C5.14671 14.4398 4.93819 14.7837 4.74705 15.1446C4.57328 15.4713 4.41689 15.7979 4.26051 16.1417C4.01724 16.6746 3.80872 17.2419 3.6002 17.8435C3.58283 17.8779 3.58283 17.8951 3.56545 17.9295C3.54807 17.9639 3.54807 17.9982 3.5307 18.0498C3.51332 18.0842 3.51332 18.1186 3.49594 18.1701C2.26222 22.3302 4.46902 24.7196 6.3283 22.227C6.43256 22.0723 6.53682 21.9176 6.64108 21.7629C8.60462 18.3936 12.5838 16.0042 12.5838 16.0042C12.8271 15.8494 13.0704 15.7119 13.3136 15.5572C13.3136 15.5572 13.331 15.54 13.3658 15.54C14.0434 15.1618 14.7559 14.8008 15.4683 14.5086C16.1112 14.2336 16.7889 13.9585 17.3623 13.821C17.3623 13.821 18.0226 13.6491 18.1964 12.8411C18.3181 12.2567 18.7525 11.4144 19.7082 10.9674C19.9341 10.8471 20.1773 10.7611 20.4032 10.7096C20.6639 10.658 20.9245 10.6408 21.1678 10.6408C21.3242 10.6408 21.4632 10.658 21.5848 10.6924C22.8012 10.933 23.7916 11.9129 23.948 13.2193C24.1218 14.8008 23.0097 16.2276 21.4284 16.4167C20.6465 16.5199 19.9167 16.348 19.3085 15.8838C18.6308 15.6088 18.0922 15.7807 17.901 15.8666C17.3102 16.1933 16.7368 16.5542 16.1807 16.9324C15.1555 17.6888 14.3562 18.4624 14.0261 18.789C13.3136 19.511 12.7055 20.2845 12.1494 21.0925C12.1147 21.1441 12.0973 21.1784 12.0625 21.23C12.0625 21.2472 12.0452 21.2472 12.0452 21.2644C11.4891 22.1411 10.8983 23.2756 10.4118 24.6337C10.377 24.7368 10.3423 24.84 10.3075 24.9603C9.78622 26.7137 10.9157 27.4013 12.2189 27.6592C12.2189 27.6592 13.2441 27.8483 14.7211 27.7451C14.808 27.7451 14.8775 27.7279 14.947 27.7279C15.3119 27.6764 15.6942 27.642 16.0591 27.5732C18.6134 27.1435 20.855 26.0949 22.7838 24.3758C25.1991 22.227 26.6587 19.5454 27.1105 16.3652C27.5797 13.1678 26.9541 10.1767 25.1991 7.4434Z",
    fill: "#FFC40C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15744_303326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkcell);
export default __webpack_public_path__ + "static/media/Turkcell.706dd47b306a24b8f6891308cc7b55af.svg";
export { ForwardRef as ReactComponent };